import { useTernaryDarkMode } from 'usehooks-ts';

const APPEARANCE_KEY = 'APPEARANCE';

export interface UseThemeResult {
  isDarkMode: boolean;
}

export function useTheme(): UseThemeResult {
  /**
   * This only provides a readonly value for now until
   * the ember theme service is updated to
   * listen to changes in local storage.
   */
  const { isDarkMode } = useTernaryDarkMode({
    localStorageKey: APPEARANCE_KEY,
    initializeWithValue: true,
  });

  return { isDarkMode };
}
